// Literales y medidas de la sección de recinto de la ficha de evento, fuera del
// JSX igual que en `PerformanceHighlights/constants.ts` y
// `PerformanceBuyBox/constants.ts`.

/** Encabezado de la sección (Figma `5900:18988` / `5900:27397`). */
export const VENUE_HEADING = 'Localización del evento'

/**
 * CTA principal del bloque en el diseño nuevo: pasa de enlace subrayado a
 * botón negro (`Button variant="filled" size="m"`). Intercambia su papel con
 * `DIRECTIONS_LABEL`, que antes era el botón.
 */
export const MORE_EVENTS_LABEL = 'Más eventos en este recinto'

/** Enlace a las indicaciones de Google Maps — subrayado, ya no botón. */
export const DIRECTIONS_LABEL = 'Cómo llegar'

/**
 * Tamaño del glifo de las filas de contacto. La fila que lo contiene fija su
 * propio `min-height` en el SCSS — son dos medidas distintas.
 */
export const CONTACT_ICON_SIZE = 24

/**
 * Separador entre teléfono y fax (Figma: bala, no punto medio). Decorativo y
 * oculto en mobile, donde el diseño parte la fila en dos líneas.
 */
export const PHONE_SEPARATOR = '•'

/** `module_name` de los `click` de esta sección (`Ubicación Detalles Producto.csv`). */
export const VENUE_LOCATION_MODULE_NAME = 'venue_location'
